import { GenericDataType } from "src/modules/enaio/netgen/GenericDataType";
import { TableCellType } from "./TableCellType";

export enum FrontendFieldType {
    //netgen start
    string = 0,
    int = 1,
    decimal = 2,
    bool = 3,
    date = 4,
    dateTime = 5,
    time = 6,
    textArea = 7,
    maskField = 8,
    password = 9,
    dropdown = 10,
    dropdownCascade = 11,
    dropdownMulti = 12,
    listBox = 13,
    radioButton = 14,
    button = 15,
    buttonAsLink = 16,
    table = 17,
    groupBox = 18,
    color = 19,
    rating = 20,
    stringList = 21,
    fileSelect = 22,
    fileUpload = 23,
    imageUpload = 24,
    pageControl = 25,
    page = 26,
    splitter = 27,
    spinner = 28,
    custom = 29,
    selectButton = 30
    //netgen end
}

export namespace FrontendFieldType{
    export function fromGenericDataType(value: GenericDataType): FrontendFieldType {
        switch (value) {
            case GenericDataType.string:
                return FrontendFieldType.string;
            case GenericDataType.int:
                return FrontendFieldType.int;
            case GenericDataType.decimal:
                return FrontendFieldType.decimal;
            case GenericDataType.bool:
                return FrontendFieldType.bool;
            case GenericDataType.date:
                return FrontendFieldType.date;
            case GenericDataType.dateTime:
                return FrontendFieldType.date;
            case GenericDataType.time:
                return FrontendFieldType.time;
            case GenericDataType.array:
                return FrontendFieldType.string;
            case GenericDataType.object:
                return FrontendFieldType.string;
        }
    }

    export function toTableCellType(value: FrontendFieldType): TableCellType {
        switch (value) {
            case FrontendFieldType.string:
            case FrontendFieldType.textArea:
            case FrontendFieldType.maskField:
            case FrontendFieldType.password:
            case FrontendFieldType.stringList:
                return TableCellType.string;

            case FrontendFieldType.int:
                return TableCellType.int;

            case FrontendFieldType.decimal:
                return TableCellType.decimal;

            case FrontendFieldType.bool:
            case FrontendFieldType.radioButton:
                return TableCellType.bool;

            case FrontendFieldType.date:
                return TableCellType.date;

            case FrontendFieldType.dateTime:
                return TableCellType.dateTime;

            case FrontendFieldType.color:
                return TableCellType.color;

            case FrontendFieldType.button:
            case FrontendFieldType.buttonAsLink:
                return TableCellType.button;

            case FrontendFieldType.fileSelect:
            case FrontendFieldType.fileUpload:
            case FrontendFieldType.imageUpload:
                return TableCellType.image;

            default:
                return TableCellType.string;
        }
    }

    export function getDefaultValue(value: FrontendFieldType): any {
        switch (value) {
            case FrontendFieldType.string:
            case FrontendFieldType.textArea:
            case FrontendFieldType.password:
            case FrontendFieldType.maskField:
            case FrontendFieldType.dropdown:
            case FrontendFieldType.dropdownCascade:
            case FrontendFieldType.dropdownMulti:
            case FrontendFieldType.selectButton:
                return "";
            case FrontendFieldType.bool:
                return false;
            case FrontendFieldType.table:
                return [];
            default:
                return null;
        }
    }

    export function hasLabel(value: FrontendFieldType): boolean {
        return value != FrontendFieldType.bool && value != FrontendFieldType.radioButton && value != FrontendFieldType.button && value != FrontendFieldType.buttonAsLink;
    }
}
